export type LandmarkDensityPresetName = 'balanced' | 'minimalClutter';

export type LandmarkDensityPreset = {
  showLandmarksAtZoom: number;
  maxPinsAtZoom: number;
  minLandmarksAtMediumZoom: number;
  featuredLandmarksWithItinerary: number;
  featuredLandmarksWithoutItinerary: number;
  finalLandmarkReserveDayView: number;
  finalLandmarkReserveAllDays: number;
  landmarkFetchLimitFull: number;
  landmarkFetchLimitPreview: number;
};

export const LANDMARK_DENSITY_PRESETS: Record<LandmarkDensityPresetName, LandmarkDensityPreset> = {
  balanced: {
    showLandmarksAtZoom: 10,
    maxPinsAtZoom: 48,
    minLandmarksAtMediumZoom: 4,
    featuredLandmarksWithItinerary: 6,
    featuredLandmarksWithoutItinerary: 10,
    finalLandmarkReserveDayView: 14,
    finalLandmarkReserveAllDays: 10,
    landmarkFetchLimitFull: 35,
    landmarkFetchLimitPreview: 16,
  },
  minimalClutter: {
    showLandmarksAtZoom: 11,
    maxPinsAtZoom: 38,
    minLandmarksAtMediumZoom: 2,
    featuredLandmarksWithItinerary: 3,
    featuredLandmarksWithoutItinerary: 6,
    finalLandmarkReserveDayView: 8,
    finalLandmarkReserveAllDays: 5,
    landmarkFetchLimitFull: 20,
    landmarkFetchLimitPreview: 10,
  },
};

/** Default to lower landmark density for dense city views. */
export const DEFAULT_LANDMARK_DENSITY_PRESET: LandmarkDensityPresetName = 'minimalClutter';

export const getLandmarkDensityPreset = (
  name: LandmarkDensityPresetName = DEFAULT_LANDMARK_DENSITY_PRESET,
): LandmarkDensityPreset => LANDMARK_DENSITY_PRESETS[name];
